import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const testimonials = [{
    initials: 'ML',
    name: 'María Laura G.',
    location: 'La Plata, Buenos Aires',
    text: '"Por fin pude organizar todas mis materias sin estrés. El MegaPack Universitario me cambió la forma de estudiar. Lo empecé un domingo y el lunes ya tenía todo planificado."'
  }, {
    initials: 'CR',
    name: 'Claudia R.',
    location: 'Mar del Plata, Buenos Aires',
    text: '"Los templates y guías me ayudaron a cumplir con todas las entregas a tiempo. Nunca pensé que organizarme pudiera ser tan simple."'
  }, {
    initials: 'SM',
    name: 'Sergio M.',
    location: 'Bahía Blanca, Buenos Aires',
    text: '"Las estrategias para exámenes me dieron mucha tranquilidad. Llegué al final del cuatrimestre sin el estrés de siempre. Vale cada peso."'
  }];
  return <section id="testimonios" className="w-full py-24 bg-transparent px-4 relative" data-id="element-374">
      <div className="max-w-6xl mx-auto flex flex-col items-center relative z-10" data-id="element-375">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-white mb-16 text-center max-w-4xl leading-tight" data-id="element-376">
          Estudiantes que ya mejoraron su cursada
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full" data-id="element-377">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-cardBg rounded-2xl p-8 border border-white/5 flex flex-col hover:-translate-y-2 transition-transform duration-300 hover:border-gradPurple/30" data-id="element-378">
              <div className="flex items-center gap-4 mb-6" data-id="element-379">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gradPurple to-gradPink flex items-center justify-center text-white font-bold text-xl" data-id="element-380">
                  {testimonial.initials}
                </div>
                <div data-id="element-381">
                  <h3 className="font-bold text-white text-lg" data-id="element-382">
                    {testimonial.name}
                  </h3>
                  <p className="text-textMuted text-sm font-medium" data-id="element-383">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <div className="flex gap-1 mb-4" data-id="element-384">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gradOrange text-gradOrange drop-shadow-[0_0_5px_rgba(255,107,0,0.5)]" data-id="element-385" />)}
              </div>
              <p className="text-textMuted italic flex-1 text-base font-medium leading-relaxed" data-id="element-386">
                {testimonial.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}